import updateNotes from '../Services/updateNotes'

export default () => (dispatch) => {

  dispatch(updateNotes())

}
